import React, { useEffect, useRef, useState } from "react";
import { Smartphone, ArrowRight, Loader2 } from "lucide-react";
import api from "@/lib/api";

const CORE_URL = process.env.REACT_APP_PROGERE_CORE_URL || "https://progere.ca";
const CORE_LOGIN_URL = process.env.REACT_APP_PROGERE_CORE_LOGIN_URL || "https://progere.ca/connexion";
const DELAY_MS = parseInt(process.env.REACT_APP_PROGERE_MOBILE_REDIRECT_DELAY_MS || "3000", 10);

export function ProgereDownloadAppButton({ variant = "card", size = "md", className = "" }) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(Math.ceil(DELAY_MS / 1000));
  const timers = useRef([]);

  const clearTimers = () => { timers.current.forEach((t) => clearTimeout(t) || clearInterval(t)); timers.current = []; };
  useEffect(() => () => clearTimers(), []);

  const goToCore = async () => {
    const hasToken = !!localStorage.getItem("pg_token");
    if (!hasToken) { window.location.href = CORE_LOGIN_URL; return; }
    try {
      const { data } = await api.get("/mobile/core-redirect"); // destination déterminée côté serveur
      window.location.href = data?.url || CORE_URL;
    } catch {
      window.location.href = CORE_LOGIN_URL;
    }
  };

  const start = () => {
    setOpen(true);
    setCount(Math.ceil(DELAY_MS / 1000));
    const iv = setInterval(() => setCount((c) => (c > 1 ? c - 1 : c)), 1000);
    timers.current.push(iv);
    timers.current.push(setTimeout(() => { clearTimers(); goToCore(); }, DELAY_MS));
  };

  const cls = ["pg-dl-btn", `pg-dl-btn--${variant}`, `pg-dl-btn--${size}`, className].filter(Boolean).join(" ");

  return (
    <>
      <button type="button" className={cls} onClick={start} data-testid="download-app-btn" aria-label="PROGÈRE arrive bientôt">
        <span className="pg-dl-btn__icon"><Smartphone size={18} aria-hidden="true" /></span>
        <span className="pg-dl-btn__content">
          <span className="pg-dl-btn__title">PROGÈRE arrive bientôt</span>
          {size !== "compact" && <span className="pg-dl-btn__subtitle">Bientôt disponible sur Apple et Android</span>}
        </span>
        <ArrowRight className="pg-dl-btn__action" size={16} aria-hidden="true" />
      </button>

      {open && (
        <div className="pg-dl-modal__backdrop" role="presentation" data-testid="mobile-coming-modal">
          <section className="pg-dl-modal" role="dialog" aria-modal="true" aria-labelledby="pg-mobile-title" style={{ maxWidth: 420, textAlign: "center" }}>
            <div className="pg-dl-modal__brand progere-brand-metal progere-brand-metal--medium" style={{ justifyContent: "center" }}>
              <span className="progere-brand-prog">PRO</span><span className="progere-brand-ere -ml-0.5">GÈRE</span><span className="progere-brand-module">&nbsp;MOBILE</span>
            </div>
            <h2 id="pg-mobile-title">PROGÈRE arrive bientôt</h2>
            <p>L'application mobile PROGÈRE sera bientôt disponible sur Apple et Android.<br />Vous allez être redirigé vers votre PROGÈRE CORE.</p>
            <div className="pg-dl-countdown" data-testid="mobile-countdown">
              <span className="pg-dl-countdown__num">{count}</span>
              <Loader2 size={16} className="animate-spin" style={{ color: "#bd952a" }} />
            </div>
            <button type="button" className="pg-dl-primary" onClick={() => { clearTimers(); goToCore(); }} data-testid="mobile-goto-core" style={{ width: "100%", marginTop: 18 }}>
              Continuer vers PROGÈRE CORE <ArrowRight size={15} />
            </button>
          </section>
        </div>
      )}
    </>
  );
}
